// pages/admins/permissions/PermissionLegend.jsx
//
// A single, icon-led row explaining every color/state an admin will see
// anywhere on this screen -- Allowed / Denied / Inherited from Role / User
// Override / Partial (mixed, module header only) / Not available. Purely
// explanatory (no data, no handlers); exists so a non-technical admin never
// has to guess what a color means.
import React from "react";

const LEGEND_ITEMS = [
  { icon: "fa-circle-check", cls: "pm-state-allowed", label: "Allowed", hint: "Access is granted" },
  { icon: "fa-circle-xmark", cls: "pm-state-denied", label: "Denied", hint: "Access is blocked" },
  { icon: "fa-diagram-project", cls: "pm-source-role", label: "Inherited from Role", hint: "No user-specific change" },
  { icon: "fa-user-pen", cls: "pm-source-override", label: "User Override", hint: "Changed for this user only" },
  { icon: "fa-adjust", cls: "pm-state-partial", label: "Partial / Mixed", hint: "Module has both allowed and denied" },
  { icon: "fa-lock", cls: "pm-state-disabled", label: "Not available", hint: "Read-only / not configurable" },
];

export default function PermissionLegend() {
  return (
    <div className="pm-legend" role="note" aria-label="Permission state legend">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.label} className={`pm-legend-item ${item.cls}`} title={item.hint}>
          <i className={`fa-solid ${item.icon}`} aria-hidden="true"></i>
          {item.label}
        </span>
      ))}
    </div>
  );
}
